/**
 * Multiple Job Locations Handler
 * Manages the multiple locations toggle and dynamic location form adding/removing
 */

import * as bootstrap from 'bootstrap';

document.addEventListener('DOMContentLoaded', function() {
    const multipleLocationsToggle = document.querySelector('#multipleLocationsToggle');
    const multipleLocationsInput = document.querySelector('#id_multiple_locations');
    const legacyFields = document.querySelector('#legacyLocationFields');
    const multipleFields = document.querySelector('#multipleLocationFields');
    const addLocationBtn = document.querySelector('#addLocationBtn');
    const formsetContainer = document.querySelector('#locationFormsetContainer');

    if (!multipleLocationsToggle) return;

    // Handle multiple locations toggle
    const toggleButtons = multipleLocationsToggle.querySelectorAll('.form__custom-toggle .btn');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const value = this.value === 'True';

            // Update hidden input
            multipleLocationsInput.value = value;

            // Update button states
            toggleButtons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            // Toggle visibility
            if (value) {
                legacyFields.classList.add('d-none');
                multipleFields.classList.remove('d-none');
            } else {
                legacyFields.classList.remove('d-none');
                multipleFields.classList.add('d-none');
            }
        });
    });

    // Initialize toggle state
    const currentValue = multipleLocationsInput.value === 'True' || multipleLocationsInput.value === 'true';
    toggleButtons.forEach(btn => {
        if ((btn.value === 'True') === currentValue) {
            btn.classList.add('active');
        }
    });

    // Handle add location button
    if (addLocationBtn) {
        addLocationBtn.addEventListener('click', function(e) {
            e.preventDefault();
            addNewLocationForm();
        });
    }

    // Handle remove location modal
    let locationToRemove = null;

    // When clicking "Delete Location" in dropdown menu
    document.addEventListener('click', function(e) {
        const removeLink = e.target.closest('.remove-location-link');
        if (removeLink) {
            const locationIndex = removeLink.getAttribute('data-location-index');
            const locationType = removeLink.getAttribute('data-location-type');

            // Store the location to remove
            locationToRemove = document.querySelector(`.location-form-item[data-location-index="${locationIndex}"]`);

            // Update modal text
            const modal = document.querySelector('#confirmRemoveLocationModal');
            const locationName = modal.querySelector('.location-type-name');
            if (locationName) {
                locationName.textContent = locationType;
            }
        }
    });

    // When confirming deletion in modal
    const confirmRemoveBtn = document.querySelector('#confirmRemoveLocationBtn');
    if (confirmRemoveBtn) {
        confirmRemoveBtn.addEventListener('click', function() {
            if (locationToRemove) {
                removeLocationForm(locationToRemove);
                locationToRemove = null;

                // Close the modal
                const modal = bootstrap.Modal.getInstance(document.querySelector('#confirmRemoveLocationModal'));
                if (modal) {
                    modal.hide();
                }
            }
        });
    }

    // Handle contenteditable location type titles
    document.addEventListener('input', function(e) {
        if (e.target.classList.contains('editable-title')) {
            syncLocationTypeFromTitle(e.target);
        }
    });

    // Prevent line breaks in contenteditable titles
    document.addEventListener('keydown', function(e) {
        if (e.target.classList.contains('editable-title') && e.key === 'Enter') {
            e.preventDefault();
            e.target.blur(); // Remove focus when Enter is pressed
        }
    });

    /**
     * Add a new location form to the formset
     */
    function addNewLocationForm() {
        const totalFormsInput = document.querySelector('#id_job_locations-TOTAL_FORMS');
        const currentFormCount = parseInt(totalFormsInput.value);
        const newFormCount = currentFormCount + 1;

        // Get the last form as template
        const lastForm = formsetContainer.querySelector('.location-form-item:last-of-type');
        if (!lastForm) return;

        // Clone the form
        const newForm = lastForm.cloneNode(true);

        // Update form index
        newForm.setAttribute('data-location-index', currentFormCount);

        // Update all field names and IDs in the new form
        const formElements = newForm.querySelectorAll('input, select, textarea');
        formElements.forEach(element => {
            // Update name attribute
            if (element.name) {
                element.name = element.name.replace(
                    /job_locations-\d+-/,
                    `job_locations-${currentFormCount}-`
                );
            }

            // Update id attribute
            if (element.id) {
                element.id = element.id.replace(
                    /id_job_locations-\d+-/,
                    `id_job_locations-${currentFormCount}-`
                );
            }

            // Clear values except hidden fields
            if (element.type !== 'hidden' || element.name.endsWith('-id')) {
                if (element.name.endsWith('-id')) {
                    element.value = ''; // Clear the ID for new forms
                } else if (element.name.endsWith('-order')) {
                    element.value = currentFormCount;
                } else if (element.name.endsWith('-DELETE')) {
                    element.checked = false;
                } else if (element.tagName === 'TEXTAREA') {
                    element.value = '';
                } else if (element.type !== 'hidden') {
                    element.value = '';
                }
            }
        });

        // Update the location type display
        const typeDisplay = newForm.querySelector('.location-type-display');
        if (typeDisplay) {
            typeDisplay.textContent = `Pickup Location ${newFormCount}`;
        }

        // Update the location type input default value
        const locationTypeInput = newForm.querySelector('input[id*="location_type"]');
        if (locationTypeInput) {
            locationTypeInput.value = `Pickup Location ${newFormCount}`;
        }

        // Ensure remove button is visible
        const removeBtn = newForm.querySelector('.remove-location-btn');
        if (removeBtn) {
            removeBtn.style.display = 'inline-flex';
        }

        // Append to container
        formsetContainer.appendChild(newForm);

        // Update total forms count
        totalFormsInput.value = newFormCount;

        // Scroll to new form
        newForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /**
     * Remove a location form from the formset
     */
    function removeLocationForm(formElement) {
        // Mark for deletion instead of removing from DOM
        const deleteInput = formElement.querySelector('input[name$="-DELETE"]');
        if (deleteInput) {
            deleteInput.checked = true;
            formElement.style.display = 'none';
        } else {
            // If no DELETE checkbox (shouldn't happen), just hide it
            formElement.style.display = 'none';
        }
    }

    /**
     * Sync the hidden location_type input from the contenteditable title
     */
    function syncLocationTypeFromTitle(titleElement) {
        const locationWrapper = titleElement.closest('.location-type-wrapper');
        if (!locationWrapper) return;

        const hiddenInput = locationWrapper.querySelector('input[id*="location_type"]');
        if (hiddenInput) {
            hiddenInput.value = titleElement.textContent.trim();
        }
    }

    /**
     * Update the location type display header when input changes
     */
    function updateLocationTypeDisplay(input) {
        const formItem = input.closest('.location-form-item');
        if (!formItem) return;

        const typeDisplay = formItem.querySelector('.location-type-display');
        if (typeDisplay && input.value) {
            typeDisplay.textContent = input.value;
        }
    }

    // Initialize all location type displays and sync from contenteditable
    const locationTypeInputs = document.querySelectorAll('input[id*="location_type"]');
    locationTypeInputs.forEach(input => {
        if (input.value) {
            updateLocationTypeDisplay(input);
        }
    });

    // Initialize contenteditable titles with current values
    const editableTitles = document.querySelectorAll('.editable-title');
    editableTitles.forEach(title => {
        const wrapper = title.closest('.location-type-wrapper');
        if (wrapper) {
            const input = wrapper.querySelector('input[id*="location_type"]');
            if (input && input.value) {
                title.textContent = input.value;
            }
        }
    });
});